import React from 'react';
import { ImpAccordionItem, ImpListHeader, ImpSurface, } from '../..';
export function ImpAccordion({ items, title, staticOpen, surfaceProps, headerVariant = 'default', }) {
    const [openIndex, setOpenIndex] = React.useState(null);
    return (React.createElement(ImpSurface, { hasBorderRadius: true, ...surfaceProps },
        title && React.createElement(ImpListHeader, { title: title, variant: headerVariant }),
        items.map((item, index) => {
            const itemCanOpen = item.content !== undefined && !staticOpen;
            return (React.createElement(ImpAccordionItem, { key: index, ...item, staticOpen: staticOpen, onClick: !itemCanOpen
                    ? undefined
                    : () => {
                        if (openIndex === index) {
                            setOpenIndex(null);
                        }
                        else {
                            setOpenIndex(index);
                        }
                    }, open: openIndex === index || staticOpen, dividerBottom: index !== items.length - 1 }));
        })));
}
//# sourceMappingURL=ImpAccordion.js.map